﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Requisitos } from "Entities/Requisitos/Requisitos";
import { Ropa } from "Entities/Ropa/Ropa";
import { catAreasPersonal } from "../Categorias y Estados/catAreasPersonal";


const columns = () =>
(
    {
        c_puestotrabajo_id: new EntityColumn<string>({ name: 'c_puestotrabajo_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Puesto Id' }),
        vc_descripcion: new EntityColumn<string>({ name: 'vc_descripcion', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Descripción' }),
        c_areapersonal_id: new EntityColumn<string>({ name: 'c_areapersonal_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Área personal' }),
        vc_requisitos: new EntityColumn<string[]>({ name: 'vc_requisitos', type: 'varchar', length: 0, flags: c.Edit | EntityColumnFlags.nullable,  prompt: 'Requisitos de ingreso', isArray: true }),
        vc_ropa: new EntityColumn<string[]>({ name: 'vc_ropa', type: 'varchar', length: 0, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Ropa', isArray: true }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        pues_brwStandard: { name: 'pues_brwStandard', keyMappings: { c_puestotrabajo_id: 0 } }
    }
)


const lookups = () =>
(
    {
        'AreasPersonal': {
            name: 'AreasPersonal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catAreasPersonal(client, parentKeys)
        },
        'Requisitos': {
            name: 'Requisitos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Requisitos(client, parentKeys)
        },
        'Ropa': {
            name: 'Ropa',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Ropa(client, parentKeys)
        },
    }
)

export class PuestosTrabajoDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('PuestosTrabajo');
    }
}